import { render } from "./RevRecMenu.vue?vue&type=template&id=5f02ea30&scoped=true"
const script = {}

import "./RevRecMenu.vue?vue&type=style&index=0&id=5f02ea30&scoped=true&lang=css"

import exportComponent from "/Users/cb-it-01-1886/Documents/Chargbe Design/cb-payments-vue/cb-payments-dash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f02ea30"]])

export default __exports__